import React from 'react'
import { FormTinsion } from './FormTinsion';
import { DeleteTinsion } from './DeleteTinsion';
import { Dialog } from 'primereact/dialog';

export const ModalTinsion = (props) => {

    const {
        modal, tittle, closeDialog, method,
        name,
        handleInputChange, loading,titleDelete,
        saveCreate,saveUpdateBacterium,saveDeleteBacterium
    } = props;

    return (
         <Dialog 
            header={tittle}
            visible={modal}
            onHide={closeDialog}
            closable={true}
            modal
            blockScroll
            className='medium-dialog'
        >
            {
                method === "create"
                    ? <FormTinsion
                        button={"Crear"}
                        {...{ closeDialog, loading,name, handleInputChange, methodAction: saveCreate }}
                    />
                    : (method === "update")
                        ?
                        <FormTinsion
                            button={"Actualizar"}
                            {...{ closeDialog, loading,name, handleInputChange,methodAction: saveUpdateBacterium }} />
                        :
                            null
            }
        </Dialog>
    )
}
